import React from 'react';
import PropTypes from 'prop-types';

const EditIcon = ({ className, color }) => (
  <svg
    className={className}
    width='19px'
    height='15px'
    viewBox='0 0 19 15'
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
  >
    <g id='Design' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
      <g id='edit' transform='translate(-1.000000, 0.000000)' strokeWidth='1.3'>
        <g
          id='Group-12'
          transform='translate(3.000000, 12.000000)'
          stroke='#BCCEFE'
          strokeLinecap='square'
        >
          <path d='M0.5,1.5 L9.5,1.5' id='Line-4' />
          <path d='M12.5,1.5 L15.5,1.5' id='Line-4-Copy-3' />
        </g>
        <g
          id='Group-8'
          transform='translate(8.854703, 7.435262) rotate(-3.000000) translate(-8.854703, -7.435262) translate(0.354703, 0.435262)'
          stroke='#2974FF'
        >
          <path
            d='M1.44702142,12.9404583 L3.58232323,13.0532842 C3.88774466,13.0507355 4.18327555,12.9446928 4.42064085,12.7524782 L15.0676381,4.13070983 C15.647066,3.66149836 15.7364141,2.81140817 15.2672026,2.23198026 L14.5192692,1.30835938 C14.0500577,0.728931463 13.1999675,0.639583383 12.6205396,1.10879486 L2.06193472,9.6589845 C1.78860543,9.88032219 1.61244617,10.1995909 1.57459721,10.5061671 L1.44702142,12.9404583 Z'
            id='Rectangle-6'
          />
          <path
            d='M11.710998,2.28381187 L13.9194301,5.01099838 L11.710998,2.28381187 Z'
            id='Line-4-Copy'
            strokeLinecap='square'
          />
          <path
            d='M2.38524649,9.83565656 L4.59367858,12.5628431 L2.38524649,9.83565656 Z'
            id='Line-4-Copy-2'
            strokeLinecap='square'
          />
        </g>
      </g>
    </g>
  </svg>
);

EditIcon.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
};

export default EditIcon;



// WEBPACK FOOTER //
// ./src/icons/EditIcon.js